import React from "react";
import { useSelector } from "react-redux";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import Step5 from "./Step5";
import Step6 from "./Step6";
import { Elements } from "@stripe/react-stripe-js";
import VoucherStep2 from "../../Booking/Form/buyVoucher/VoucherStep2";
import MemebershipStep2 from "../../Booking/Form/buyMembership/MemebershipStep2";
import MemebershipStep3 from "../../Booking/Form/buyMembership/MemebershipStep3";
import getStripeClient from "pages/getStripeClient";
import SubscriptionStep2 from "../../Booking/Form/buySubscription/SubscriptionStep2";
import SubscriptionStep3 from "../../Booking/Form/buySubscription/SubscriptionStep3";
import config from "../../../config";

const BookingForm = () => {
  const isBookingStep = useSelector((state) => state.booking.isBookingStep);
  const isBookingSelectedServicesData = useSelector((state) => state.booking.isBookingSelectedServicesData);
  const isBookingSelectedMembershipData = useSelector((state) => state.booking.isBookingSelectedMembershipData);
  const bookingStepName = useSelector((state) => state.booking.isBookingStepName);
  const isBookingApi = useSelector((state) => state.booking.isBookingApi);
  const isBookingSelectedSubscriptionData = useSelector((state) => state.booking.isBookingSelectedSubscriptionData);


  const stripePromise = getStripeClient();
  //   const supplierOptionsData = isSupplierOption;
  //   const taxOptionsData = isTaxOption;
  return (
    <>
      <div className="select-option-wrapper">
        {isBookingStep === 1 && <Step1 isBookingStep={isBookingStep} bookingStepName={bookingStepName} isBookingSelectedServicesData={isBookingSelectedServicesData} />}
        {isBookingStep === 2 && bookingStepName === "BookServices" && <Step2 isBookingStep={isBookingStep} bookingStepName={bookingStepName} isBookingSelectedServicesData={isBookingSelectedServicesData}  />}
        {isBookingStep === 3 && bookingStepName === "BookServices" && <Step3 isBookingStep={isBookingStep} bookingStepName={bookingStepName} isBookingSelectedServicesData={isBookingSelectedServicesData} />}
        {isBookingStep === 4 && bookingStepName === "BookServices" && <Step4 isBookingStep={isBookingStep} bookingStepName={bookingStepName} isBookingSelectedServicesData={isBookingSelectedServicesData} />}
        {isBookingStep === 5 && bookingStepName === "BookServices" && <Step5 isBookingStep={isBookingStep} bookingStepName={bookingStepName} isBookingSelectedServicesData={isBookingSelectedServicesData} />}
        {isBookingStep === 6 && bookingStepName === "BookServices" && (
          <Elements stripe={stripePromise}>
            <Step6 isBookingStep={isBookingStep} bookingStepName={bookingStepName} isBookingSelectedServicesData={isBookingSelectedServicesData} />
          </Elements>
        )}
      </div>
      {(isBookingStep === 2 || isBookingStep === 3 || isBookingStep === 4) && bookingStepName !== "BookServices" && <div className="select-option-wrapper">
        <div className="row mb-4">
          <div className="col-lg-8 mx-auto">
            <div className="booking-description text-center mb-4">
              <p>
                <b> {isBookingApi.salon.business_name} </b> {isBookingApi.salon.business_address}
              </p>
            </div>
            <div className="online-booking-content bg-white">
              <div className="booking-logo d-flex justify-content-center">
                <img className="rounded booking-link-logo" src={isBookingApi.salon.logo_url} width="136" alt="" />
              </div>
              {isBookingStep === 2 && bookingStepName === "BuyVoucher" && (
                <Elements stripe={stripePromise}>
                  <VoucherStep2 isBookingStep={isBookingStep} bookingStepName={bookingStepName} />
                </Elements>
              )}
              {isBookingStep === 2 && bookingStepName === "BuyMembership" && <MemebershipStep2 isBookingStep={isBookingStep} bookingStepName={bookingStepName} />}
              {isBookingStep === 3 && bookingStepName === "BuyMembership" && (
                <Elements stripe={stripePromise}>
                  <MemebershipStep3 isBookingStep={isBookingStep} bookingStepName={bookingStepName} isBookingSelectedMembershipData={isBookingSelectedMembershipData} />
                </Elements>
              )}
              {isBookingStep === 2 && bookingStepName === "BuySubscription" && <SubscriptionStep2 isBookingStep={isBookingStep} bookingStepName={bookingStepName} isBookingSelectedSubscriptionData={isBookingSelectedSubscriptionData} />}
              {isBookingStep === 3 && bookingStepName === "BuySubscription" && (
                <Elements stripe={stripePromise}>
                  <SubscriptionStep3 isBookingStep={isBookingStep} bookingStepName={bookingStepName} isBookingSelectedSubscriptionData={isBookingSelectedSubscriptionData} />
                </Elements>
              )}
              {isBookingStep === 4 && bookingStepName === "BuySubscription" && ( 
                <div className="d-flex flex-column align-items-center justify-content-center min-vh-100 text-center p-4">
                  <div className="success-icon mb-4">
                    <img src={config.imagepath + "success.svg"} alt="" />
                  </div>
                  <h2 className="mb-3" style={{ color: "#3a3432" }}>
                      Subscription Purchase Successful
                  </h2>
                  <p className="text-muted mb-5" style={{ maxWidth: "500px" }}>
                    Thank you!.
                  </p>
                </div>)}
            </div>
          </div>
        </div>
      </div>}
    </>
  );
};

export default BookingForm;
